import { _ } from "../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import FormBuilder from "./forms/FormBuilder.js";

/**
 * `EmailContentEditorWidget` renders two fields for email edition. An input
 * to edit the email subject, and a wysiwyg editor to edit its body text.
 *
 * @param {EmailContent} spec.emailContent - Container of the email subject
 * and body to be edited.
 */
export default class EmailContentEditorWidget extends Widget {
	constructor({ emailContent }) {
		super(...arguments);

		this._emailContent = emailContent;

		this._customNotificationForm = new FormBuilder({
			showActions: false,
			inputClass: "notification-input",
		});

		this._customNotificationForm.input({
			label: _("Subject"),
			name: "subject",
			accessor: () => this._emailContent.getSubject(),
			mutator: (value) => this._emailContent.setSubject(value),
		});

		this._customNotificationForm.wysiwyg({
			label: _("Notification"),
			name: "notification",
			accessor: () => this._emailContent.getBody(),
			mutator: (value) => this._emailContent.setBody(value),
			toolbarAlwaysVisible: true,
		});
	}

	renderContentOn(html) {
		html.render(this._customNotificationForm);
	}

	submit() {
		this._customNotificationForm.submit();
		this._emailContent.setEdited(true);
	}
}
